import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {withLocalize} from 'react-localize-redux';
import {XAxis, YAxis, LineSeries, VerticalBarSeries, XYPlot, HorizontalGridLines, VerticalGridLines, DiscreteColorLegend} from 'react-vis';
import AutoSizer from "react-virtualized-auto-sizer";
import { connect } from 'react-redux';
import DayJS from 'dayjs';

import '../../../../../../node_modules/react-vis/dist/style.css';
import {GRAPH_COLORS, GRAPH_GRID_COLOR_DARK, GRAPH_LEGEND_COLOR, GRAPH_MIN_WIDTH, DASHBOARD_LAYOUT_GRID, DASHBOARD_LAYOUT_INLINE, DASHBOARD_LAYOUT_FULLSIZE} from "../../../../../constants";

const propTypes = {
  inputId: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  layout: PropTypes.oneOf([DASHBOARD_LAYOUT_GRID, DASHBOARD_LAYOUT_INLINE, DASHBOARD_LAYOUT_FULLSIZE]),
};

const margins= {
  left: 50,
  right: 40
};

const tickTotalX = 4;
const tickTotalY = 4;
const tickWidth = 0;

class Graph extends Component {

  constructor(props){
    super(props);

    this.toggleLegend = this.toggleLegend.bind(this);

    this.state = {
      legend: false
    };
  }

  toggleLegend() {
    if (this.props.layout!== DASHBOARD_LAYOUT_FULLSIZE) {
      this.setState({
        legend: !this.state.legend
      });
    }
  }

  formatBitrate(value, index, scale, tickTotal){
    return `${scale.tickFormat(tickTotal, '~s')(value)}b`;
  }

  format(value, index, scale, tickTotal){
    return `${scale.tickFormat(tickTotal, '~s')(value)}`;
  }

  render(){
    if(!this.props.stats){
      return null;
    }
    return (
        <AutoSizer>
          {({ height, width }) => {
            return width > GRAPH_MIN_WIDTH ?
              <div className="graph">
                <div className="base">
                  <XYPlot
                      getX={d => d.timestamp }
                      getY={d => d.totalBitrate }
                      xType="time"
                      yDomain={[0, this.props.stats.maxTotalBitrate + (parseInt(this.props.stats.maxTotalBitrate * 0.2))]}
                      height={height}
                      width={width}
                      margin={margins}>
                    <HorizontalGridLines style={{ stroke: GRAPH_GRID_COLOR_DARK }} tickTotal={tickTotalY}/>
                    <VerticalGridLines style={{ stroke: GRAPH_GRID_COLOR_DARK }} tickTotal={tickTotalX}/>
                    <XAxis style={{ line: {stroke: GRAPH_GRID_COLOR_DARK}, text: {stroke: GRAPH_LEGEND_COLOR}}} tickTotal={tickTotalX} tickFormat={v => `${DayJS(v).format('HH:mm')}`} tickSizeOuter={0} tickSizeInner={tickWidth}/>
                    <YAxis title={this.props.translate("genericLabel.BITRATE.text")} style={{ line: {stroke: GRAPH_GRID_COLOR_DARK}, text: {stroke: GRAPH_LEGEND_COLOR}}} tickTotal={tickTotalY} tickFormat={ this.formatBitrate } tickSizeOuter={0} tickSizeInner={tickWidth}/>
                    <LineSeries getNull={(d) => d.hidden !== true} data={this.props.stats.data} color={GRAPH_COLORS[0]}/>
                  </XYPlot>
                </div>
                <div className="overlay">
                  <XYPlot
                      getX={d => d.timestamp }
                      getY={d => d.videoLostPackets }
                      yDomain={[0, Math.max(this.props.stats.maxVideoLoss, this.props.stats.maxAudioLoss)]}
                      height={height}
                      width={width}
                      margin={margins}>
                    <YAxis style={{ line: {stroke: GRAPH_GRID_COLOR_DARK}, text: {stroke: GRAPH_LEGEND_COLOR}}} orientation="right" tickSizeOuter={0} tickSizeInner={tickWidth} tickFormat={ this.format }/>
                    <VerticalBarSeries data={this.props.stats.data} color={GRAPH_COLORS[1]}/>
                  </XYPlot>
                </div>
                { this.state.legend &&
                  <div className="overlay">
                    <DiscreteColorLegend
                      width={width}
                      orientation="horizontal"
                      items={
                        this.props.stats.mpegtsUpMode ?
                        [
                          {title: this.props.translate("streamStats.STREAM_BITRATE.text"), color: GRAPH_COLORS[0], strokeWidth:10},
                          {title: this.props.translate("streamStats.STREAM_LOST.text"), color: GRAPH_COLORS[1], strokeWidth:10},
                        ] :
                        [
                          {title: this.props.translate("streamStats.STREAM_BITRATE.text"), color: GRAPH_COLORS[0], strokeWidth:10},
                          {title: this.props.translate("streamStats.VIDEO_LOST.text"), color: GRAPH_COLORS[1], strokeWidth:10},
                          {title: this.props.translate("streamStats.AUDIO_LOST.text"), color: GRAPH_COLORS[2], strokeWidth:10}
                        ]
                      }
                    />
                  </div>
                }

                <div className="overlay" onMouseOver={ this.toggleLegend } onMouseOut={ this.toggleLegend }>
                  <XYPlot
                      getX={d => d.timestamp }
                      getY={d => d.audioLostPackets}
                      yDomain={[0, Math.max(this.props.stats.maxVideoLoss, this.props.stats.maxAudioLoss)]}
                      height={height}
                      width={width}
                      margin={margins}>
                    <YAxis title={this.props.translate("genericLabel.LOST_PACKETS.text")} style={{ line: {stroke: GRAPH_GRID_COLOR_DARK}, text: {stroke: GRAPH_LEGEND_COLOR}}} orientation="right"  tickFormat={ this.format }tickSizeOuter={0} tickSizeInner={tickWidth}/>
                    <VerticalBarSeries data={this.props.stats.data} color={GRAPH_COLORS[2]}/>
                  </XYPlot>
                </div>
              </div> : null;
          }}
        </AutoSizer>
    );
  }
}

Graph.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(Graph));